(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(() => {
  const init = () => {
    const drawer = document.getElementById('RTPCartDrawer');
    if (!drawer || window.RTPCart) return;
    const root = window.Shopify.routes.root;
    let queue = Promise.resolve();
    const sectionIds = () => ['cart-drawer', document.querySelector('[data-rtp-main]')?.dataset.sectionId].filter(Boolean);
    const busy = (value) => {
      document.querySelectorAll('#RTPCartDrawer, [data-rtp-main]').forEach(node => {
        node.setAttribute('aria-busy', String(value));
        node.querySelectorAll('input, button[name="checkout"], button[name="update"]').forEach(input => { input.disabled = value; });
      });
    };
    const render = (sections) => {
      const parsed = {};
      for (const id of sectionIds()) {
        if (!sections?.[id]) throw new Error('Cart section unavailable');
        parsed[id] = new DOMParser().parseFromString(sections[id], 'text/html');
      }
      const content = parsed['cart-drawer'].querySelector('[data-rtp-drawer-content]');
      if (!content) throw new Error('Cart content unavailable');
      drawer.querySelector('[data-rtp-drawer-content]').replaceWith(content);
      document.querySelectorAll('[data-cart-count]').forEach(node => { node.textContent = content.dataset.itemCount; });
      const main = document.querySelector('[data-rtp-main]');
      if (main) {
        const replacement = parsed[main.dataset.sectionId].querySelector('[data-rtp-main]');
        if (!replacement) throw new Error('Cart page unavailable');
        main.replaceWith(replacement);
      }
    };
    const fetchSections = async () => {
      const url = new URL(root, window.location.origin);
      url.searchParams.set('sections', sectionIds().join(','));
      const response = await fetch(url, { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) throw new Error('Cart unavailable');
      render(await response.json());
    };
    const run = task => {
      const operation = queue.then(async () => {
        busy(true);
        document.querySelectorAll('[data-rtp-error]').forEach(node => { node.hidden = true; });
        try { await task(); }
        finally { busy(false); }
      });
      queue = operation.catch(() => {});
      return operation;
    };
    window.RTPCart = {
      refresh: (open = false) => run(async () => {
        await fetchSections();
        if (open && !drawer.open) drawer.showModal();
      })
    };
    const change = (key, quantity, source) => run(async () => {
      const inDrawer = Boolean(source.closest('#RTPCartDrawer'));
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: sectionIds(), sections_url: window.location.pathname })
      });
      const cart = await response.json();
      if (!response.ok) {
        await fetchSections();
        throw new Error(cart.description || 'Cart update failed');
      }
      try { render(cart.sections); }
      catch { await fetchSections(); }
      const scope = inDrawer ? drawer : document.querySelector('[data-rtp-main]');
      const input = Array.from(scope?.querySelectorAll('[data-rtp-quantity]') || []).find(node => node.dataset.key === key);
      if (input) { input.disabled = false; input.focus(); }
      else if (inDrawer) drawer.querySelector('[data-rtp-close]').focus();
      else { scope?.querySelector('h1')?.focus(); }
    }).catch(() => { document.querySelectorAll('[data-rtp-error]').forEach(node => { node.hidden = false; }); });
    document.addEventListener('click', event => {
      if (!(event.target instanceof Element)) return;
      if (event.target.closest('[data-rtp-close]')) { drawer.close(); return; }
      const open = event.target.closest('[data-rtp-open]');
      if (open && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) {
        event.preventDefault();
        window.RTPCart.refresh(true).catch(() => { window.location.assign(drawer.dataset.cartUrl); });
      }
      const remove = event.target.closest('[data-rtp-remove]');
      if (remove && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) {
        event.preventDefault();
        if (remove.closest('[aria-busy="true"]')) return;
        change(remove.dataset.key, 0, remove);
      }
    });
    document.addEventListener('change', event => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || !input.matches('[data-rtp-quantity]')) return;
      if (!input.checkValidity() || input.value === '') { input.reportValidity(); return; }
      change(input.dataset.key, Number(input.value), input);
    });
    drawer.addEventListener('click', event => {
      if (event.target !== drawer) return;
      const bounds = drawer.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right) drawer.close();
    });
    window.addEventListener('pageshow', event => { if (event.persisted) window.RTPCart.refresh().catch(() => {}); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

  } catch(e) { console.error(e); }
})();
})();
